export function handleEdgeworthRequestError(
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
error, mutationType) {
    var _a, _b, _c;
    if (error && error.httpResponse) {
        if (error.httpResponse.status === 404 /* HttpStatusCode.NotFound */) {
            return { error: 'notSupported', continueSilently: true };
        }
        if (!error.httpResponse.ok &&
            ((_c = (_b = (_a = error.httpResponse) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error_data) === null || _c === void 0 ? void 0 : _c.message)) {
            return { error: error.httpResponse.data.error_data.message };
        }
        return { error: error.httpResponse.statusText };
    }
    return { error: "".concat(mutationType, " Request Error") };
}
//# sourceMappingURL=handleEdgeworthRequestError.js.map